export const transactionHistoryState = () => ({
  startDate: null,
  endDate: null,
  page: 1,
  perPage: 10,
  searchKey: "",
  awardCategory: "",
  productCodes: "",
  referenceStation: {
    isSelectedAll: true,
    value: [],
  },
});
